module.exports = __webpack_public_path__ + "static/media/checkmarkGreen.789d1ff7.svg";